import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoDataSourceBase from '../KendoDataSourceBase'
import PivotDataSourceProps from './PivotDataSourceProps'
import KendoPivotColumn from '../KendoPivotColumn'
import KendoPivotMeasure from '../KendoPivotMeasure'
import KendoPivotRow from '../KendoPivotRow'

import Schema from './Schema'
import Transport from './Transport'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Sort from '../KendoDataSourceBase/Sort'

export default {
    props: PivotDataSourceProps,
    mixins: [
        KendoDataSourceBase,
        KendoBaseComponent,
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted() {
        this._resolveChildren()

        this.kendoDataSource = new kendo.data.PivotDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.PivotDataSource(this.widgetOptions)
        },
        _resolveChildren() {
            this.resolveChildren('columns', KendoPivotColumn.name)
            this.resolveChildren('measures', KendoPivotMeasure.name)
            this.resolveChildren('rows', KendoPivotRow.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/KendoPivotDataSourceMixin.js